$(document).ready(function () {

  // SHOP NAV WIDTH
  function setNavShopWidth() {
    const navLiShop = document.querySelector('.nav-li-shop');
    if (navLiShop) {
      const width = navLiShop.offsetWidth;
      const offsetLeft = navLiShop.offsetLeft;
      document.documentElement.style.setProperty('--nav-shop-width', offsetLeft + width + 'px');
    }
    const navLiLogin = document.querySelector('.nav-li-login');
    if (navLiLogin) {
      const width = navLiLogin.offsetWidth;
      const offsetRight = window.innerWidth - (navLiLogin.offsetLeft + navLiLogin.offsetWidth);
      document.documentElement.style.setProperty('--nav-login-width', offsetRight + width + 'px');
    }
  }
  setNavShopWidth();
  window.addEventListener('resize', setNavShopWidth);

  // VIEWPORT HEIGHT MOBILE
  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  appHeight();

  // FEATURED PRODUCT SWIPER
  const featuredProductSwiper = new Swiper('.featured-product-carousel', {
    direction: 'horizontal',
    loop: true,
    pagination: {
      el: '.swiper-bullets',
      type: 'bullets',
      clickable: true
    },
  });

  // POPUPS
  $('#overlay, .close-pop-up').click(function (e) {
    e.preventDefault();
    $('html').removeClass('show-size-guide show-filters show-search show-login show-contact');
  });

  // BANNER
  $('.close-announcement').click(function (e) {
    e.preventDefault();
    $('#announcement-bar').remove();
    $("#header").removeClass('has-banner');
  });
  
  // ACCOUNT
  // LOGIN
  $('#login-trigger').click(function (e) { 
    e.preventDefault();
    $('html').addClass('show-login');
    $("#customer_email, #customer_password").val("");
  });
  $(".login-trigger-mobile").click(function (e) {
    if($('.mobile-login-container').find('#login-popup').length === 0) {
      $("#login-popup").appendTo(".mobile-login-container");
      $("#customer_email, #customer_password").val("");
      $("#customer_email").attr("placeholder", "Email");
      $("#customer_password").attr("placeholder", "Password");
    }
    $(".submenu-trigger").parent().removeClass('active');
    $(".sub-menu-container").removeClass('show');
    $(".mobile-login-container").toggleClass('show');
  });
  $(document).off('click', '.forgot-trigger').on('click', '.forgot-trigger', function(e) {
    e.preventDefault();
    console.log('Forgot password clicked');
    $("#recover-password").addClass('show');
    $("#login-container").removeClass('show');
    $(".template-customers-login .register h1").text('Reset your Password');
  });
  $(document).off('click', '.cancel-recover').on('click', '.cancel-recover', function(e) {
    e.preventDefault();
    $("#recover-password").removeClass('show');
    $("#login-container").addClass('show');
    $(".template-customers-login .register h1").text('Login');
  });

  // SIZE GUIDE
  $('a[href="#size-chart"]').click(function (e) { 
    e.preventDefault();
    $('html').addClass('show-size-guide');
  });

  // CONTACT
  $('a[href="#contact"]').click(function (e) { 
    e.preventDefault();
    $('html').addClass('show-contact');
  });

  // FILTERS
  $("#filters-trigger").click(function (e) {
    e.preventDefault();
    $('html').toggleClass('show-filters');
  });

  // SEARCH
  $(".search-trigger").click(function (e) {
    e.preventDefault();
    $('html').addClass('show-search');
    $(".search-input").focus();
  });

  // NEWSLETTER
  $(".newsletter-trigger").click(function (e) {
    e.preventDefault();
    $(this).parent().addClass('active');
    $('#mce-EMAIL').focus();
  });

  // MOBILE MENU
  $("#menu-trigger-mobile").click(function (e) {
    e.preventDefault();
    $('html').toggleClass('show-mobile-menu');
  });
  $(".submenu-trigger").click(function (e) {
    e.preventDefault();
    var index = $(this).data('index'),
        top = $(this).parent('.nav-li').position().top;
    console.log(top);
    $('.mobile-login-container').removeClass('show');
    $(".submenu-trigger").not(this).parent().removeClass('active');
    $(this).parent().toggleClass('active');
    $('.sub-menu-container').not('.sub-menu-container[data-index="' + index + '"]').removeClass('show');
    $('.sub-menu-container[data-index="' + index + '"]').toggleClass('show');
    $('.sub-menu-container[data-index="' + index + '"]').css('margin-top', 'calc(' + top + 'px - 74px)');
  });
  
});